





















import { CodeTheme, DarkMode, LightMode } from '@/api/dto/UserProfile';
import Vue, { PropType } from 'vue';

interface Data {
  themes: Array<{ name: 'dark' | 'light', value: CodeTheme, text: string, url: string }>;
}

export default Vue.extend({
  name: 'CodeThemeRadioButton',
  computed: {
    current: {
      get: function(): CodeTheme {
        return this.value;
      },
      set: function(val: CodeTheme) {
        this.$emit('input', val);
      },
    },
  },
  props: {
    value: {
      type: String as PropType<CodeTheme>,
      default: DarkMode
    }
  },
  data(): Data {
    return {
      themes: [
        { name: 'dark', value: DarkMode, text: 'ダークモード', url: '/images/mypage/setting_dark.svg' },
        { name: 'light', value: LightMode, text: 'ライトモード', url: '/images/mypage/setting_light.svg' },
      ]
    }
  }
})
